import React from 'react';

type CurvedEdgeProps = {
  /** Which edge of the band the arc sits on. The parent must be position: relative. */
  position: 'top' | 'bottom';
  /** Colour of the adjoining section outside the band (for example 'var(--paper)'), so there is no seam. */
  fill: string;
  className?: string;
};

// One shallow quadratic arc, edge to edge. bottom: the band bulges down. top: the band rises into the section above.
const PATHS = {
  bottom: 'M0 80 V0 Q720 160 1440 0 V80 Z',
  top: 'M0 0 H1440 V80 Q720 -80 0 80 Z',
} as const;

/** Decorative curve between two bands (section 3 "Curved edges"). At most three per page. Never covers text. */
const CurvedEdge: React.FC<CurvedEdgeProps> = ({ position, fill, className }) => {
  const classes = ['ui-curved-edge', `ui-curved-edge--${position}`];
  if (className) classes.push(className);
  return (
    <svg
      className={classes.join(' ')}
      viewBox="0 0 1440 80"
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      <path d={PATHS[position]} style={{ fill }} />
    </svg>
  );
};

export default CurvedEdge;
